import { renderInDocument } from '@spotahome/soyuz/client';

import BuddyUpContainer from './main';

renderInDocument(BuddyUpContainer);
